import { jsxs, jsx } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import Typography from "../Typography/Typography.js";
import './Comment.css';/* empty css             */
const Comment = ({ title, className, children }) => {
  if (!children || !title) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-comment", className), children: [
    /* @__PURE__ */ jsx(Typography.Title, { className: classnames("perxis-auto-comment__title"), headingLevel: 4, level: "h2", children: title }),
    children
  ] });
};
export {
  Comment as default
};
//# sourceMappingURL=Comment.js.map
